import { MessengerComponent } from '../messenger/messenger.component';

export class StompSocketAPI {
	webSocketEndpoint = 'https://localhost:10010/ws';
	// webSocketEndpoint = 'https://deleteme-devenablement-websocket.apps.pp01i.edc1.cf.ford.com';
	stompClient: any;
	topic = '/topic/greetings';
	messengerComponent: any;
	token = sessionStorage.getItem('token');

	constructor(messengerComponent: MessengerComponent) {
		this.messengerComponent = messengerComponent;
		//     this._connect();
	}

	//   _connect() {
	//     console.log('Initialize WebSocket Connection');
	//     let ws = new SockJS(this.webSocketEndpoint);
	//     this.stompClient = Stomp.over(ws);
	//     // * - connect(headers, connectCallback, errorCallback)
	//     let that = this;
	//     this.stompClient.connect({Authorization: 'Bearer Token: ' + this.token}, function (frame) {
	//       that.stompClient.subscribe(that.topic, function (message) {
	//         that.onMessageReceived(message);
	//       });
	//       that.stompClient.reconnect_delay = 2000;
	//     }, this.errorCallBack);
	//   }
	//
	//   errorCallBack(error) {
	//     console.log("errorCallBack -> " + typeof(error));
	//     setTimeout(() => {
	//       this._connect();
	//     }, 5000);
	//   }
	//
	//   _send(message) {
	//     console.log("Sending message: " + message);
	//     this.stompClient.send("/app/hello", {}, JSON.stringify(message));
	//   }
	//
	//   onMessageReceived(message) {
	//     console.log("Message Recieved from Server :: " + message);
	//     this.messengerComponent.handleMessage(JSON.stringify(message.body));
	//   }
}
